import { render, staticRenderFns } from "./SalonPhoto.vue?vue&type=template&id=2edc1f63&scoped=true"
import script from "./SalonPhoto.vue?vue&type=script&lang=ts"
export * from "./SalonPhoto.vue?vue&type=script&lang=ts"
import style0 from "./SalonPhoto.vue?vue&type=style&index=0&id=2edc1f63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edc1f63",
  null
  
)

export default component.exports